import React, { useEffect, useState } from 'react';
import { Box, Button, Grid, Typography, TextField, InputAdornment, IconButton } from '@mui/material';
import { Stack, ToggleButton, ToggleButtonGroup } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';

import DashboardNavbar from '../../Components/DashboardNavbar/DashboardNavbar';
import EditProjectSubmissionModal from '../../Components/Modals/EditProjectSubmissionModal';
import DeleteConfirmModal from '../../Components/Modals/DeleteConfirmModal';
import ProjectDetailModal from '../../Components/Modals/ProjectDetailModal';

import CookieLoad from '../../util/CookieLoad';
import { useLocation, useNavigate } from 'react-router-dom';


function EditPublicSite(props) {
    const { state } = useLocation();
    const [tokens, setTokens] = useState({});
    const [projects, setProjects] = useState([]);
    const [filteredProjects, setFilteredProjects] = useState([]);
    const [searchFilter, setSearchFilter] = useState("");
    const [listType, setListType] = useState('projects');

    const [selectedProject, setSelectedProject] = useState({ project_id: -1, name: '', capacity: 0, sponsor: '', start_semester: 'Fall', end_semester: 'Spring', interdisciplinary: false, documents: [], student: false, funded: false });

    const [dynamicDeleteModalProps, setDynamicDeleteModalProps] = useState({
        type: '',
        content: '',
        onDelete: () => {}
    });
    
    //const [createOpen, setCreateOpen] = useState(false);
    const [deleteOpen, setDeleteOpen] = useState(false);
    const [editProjectOpen, setEditProjectOpen] = useState(false);

    const navigate = useNavigate();

    const handleListChange = (event, value) => {
        if(value == null){
            return
        }
        setListType(value);
    };

    const handleSearchChange = (event) => {
        setSearchFilter(event.target.value);
        setFilteredProjects(projects.filter(project => project.name.toLowerCase().includes(event.target.value.toLowerCase()) ||
        project.end_semester.toLowerCase().includes(event.target.value.toLowerCase())));
    };

    const updateProject = (updatedProj) => {
        const updateFunc = proj => {
            if (proj.project_id === updatedProj.project_id) {
                return updatedProj;
            }
            return proj;
        }

        const newProjects = projects.map(updateFunc);
        const newFilteredProjects = filteredProjects.map(updateFunc);
        setProjects(newProjects);
        setFilteredProjects(newFilteredProjects);
        
    }

    async function handleEditProjectOpen(event, project) {
        event.stopPropagation();
        setSelectedProject(project);

        setEditProjectOpen(true);
    }

    function showProjectDeleteModal(event, project) {
        event.stopPropagation();
        setSelectedProject(project);

        const newProps = {
            type: 'project',
            content: project.name,
            onDelete: () => {deleteProject(project.project_id)}
        }
        setDynamicDeleteModalProps(newProps);

        setDeleteOpen(true);
    }

    function deleteProject(projectID) {
        fetch(`${process.env.REACT_APP_API_HOST}/api/file/removeAllProjectFiles/${projectID}`, {
            method: 'DELETE',
            headers: {
                Authorization: `Bearer ${tokens.access_token}`,
                'Content-Type': 'application/json'
            }
        })

        fetch(`${process.env.REACT_APP_API_HOST}/api/projects/delete/${projectID}`, {
            method: 'DELETE',
            headers: {
                Authorization: `Bearer ${tokens.access_token}`,
                'Content-Type': 'application/json'
            }
        })
            .then(res => res.ok && loadProjectData())
            .catch(error => console.error(error))
    }

    function loadProjectData(tokens) {
        function initProjectData(data) {
            setProjects(data);
            setFilteredProjects(data);
        }
        fetch(`${process.env.REACT_APP_API_HOST}/api/projects/getAllProjects`, {
        method:'GET',
        headers: {Authorization: `Bearer ${tokens.access_token}`}
        })
            .then(res => res.json())
            .then(j => initProjectData(j))
            .catch(error => console.error(error));
    }

    const ProjectList = ({item}) => {
        const [projectDetailOpen, setProjectDetailOpen] = useState(false);
        
        const handleProjectDetailOpen =()=>{
            setProjectDetailOpen(true)
        }
        const handleProjectDetailClose =()=>{
            setProjectDetailOpen(false)
        }
    
        return(
            <div>
                <ProjectDetailModal open={projectDetailOpen} handleClose={handleProjectDetailClose} data={item}/> 
                <Stack direction='row' spacing={3} style={{ cursor: 'pointer', backgroundColor: '#ECF7FF', paddingInline: 10, paddingBlock: 3, borderRadius: 8, alignItems: 'center' }} onClick={(event) => handleProjectDetailOpen(event)}>
                    <Typography style={{ width: '60%', wordBreak: "break-all" }}>{item.name}</Typography>
                    <Typography style={{ width: '20%' }}>{item.end_semester}</Typography>
                    <Stack direction='row' sx={{ width: '20%', justifyContent: 'right' }}>
                        <IconButton onClick={event => showProjectDeleteModal(event, item)}><DeleteIcon /></IconButton>
                        <IconButton onClick={event => handleEditProjectOpen(event, item)}><EditIcon /></IconButton>
                    </Stack>
                </Stack>
            </div>
        )
    }

    useEffect(() => {
        const getTokens = async () => {
            const tokens = await CookieLoad();
            if (!tokens) {
                navigate("/");
                console.log("Cannot login user");
            }
            setTokens(tokens);
            loadProjectData(tokens);
        } 
        getTokens();
    }, [])

    return (
        <Box>
            <DashboardNavbar userType="admin"/>
            <Stack spacing={1.5} sx={{p: 2, margin: "auto", maxWidth: "1200px"}}>
                <Typography variant='h4'>All Projects</Typography>
                <TextField
                    variant='outlined'
                    size='small'
                    label='Search'
                    InputProps={{
                        endAdornment: <InputAdornment position='end'><SearchIcon></SearchIcon></InputAdornment>,
                    }}
                    onChange={handleSearchChange}
                />
                {listType === 'projects' && filteredProjects.map(item => (
                    <ProjectList key={'Project' + item.project_id} item={item}/>
                ))}
                <DeleteConfirmModal open={deleteOpen} handleClose={event => { event.stopPropagation(); setDeleteOpen(false); }} type={dynamicDeleteModalProps.type} content={dynamicDeleteModalProps.content} handleDelete={dynamicDeleteModalProps.onDelete} />
                <EditProjectSubmissionModal open={editProjectOpen} handleClose={() => setEditProjectOpen(false)} tokens={tokens} project={selectedProject} updateProject={updateProject} />
            </Stack>
        </Box>
    );
}

export default EditPublicSite;